import {goToHome, logout} from "./LoginHelper";
import {UserLogged} from "./Login.style";
import {Helpers} from "@tpd-web-common-libs/nodejs-library";
import React, {useEffect, useState} from "react";

export type TInfoUtenteProps = {
    isLogoutOnly?: boolean,
    helloName?: string,
    privacyLevel?: string,
}

export const InfoUtente = (props: TInfoUtenteProps) => {

    const [isPersonificationPage, setPersonificationPage] = useState<boolean>(false);

    useEffect(() => {
        if (Helpers.EnvironmentHelper.isClientSide()) {
            setPersonificationPage(window.location.href.includes("home-superuser"));
        }
    }, []);

    return (
        <>
            <UserLogged className="user-logger-wrapper">
                <div className="tpd-login-header-user-logged-container" data-testid="info-utente">
                    {!props.isLogoutOnly && (
                        <a
                            href="javascript:void(0)"
                            className="tpd-login-header-name show-desktop-only"
                            onClick={goToHome}
                            title={isPersonificationPage
                                ? 'Il Super User non può accedere in Area Riservata senza impersonificare un utente'
                                : 'Clicca qui per accedere alla tua Area Riservata'}>
                            {props.helloName ? (
                                <>
                                    <div className="tpd_top_icon_third_greating_type hello-name"
                                         data-testid="info-utente-hello-name">
                                        Ciao
                                    </div>
                                    <div className="tpd_top_icon_third_greating_name hello-name">
                                        {props.privacyLevel && props.privacyLevel !== "" ? "(" + props.privacyLevel + ")" : ""}
                                        {props.helloName}
                                    </div>
                                </>
                            ) : (
                                <div className="tpd_top_icon_third_greating_name">Area Riservata</div>
                            )}
                        </a>
                    )}
                    <a
                        href="javascript:void(0)"
                        className="tpd-login-header-name-esci"
                        onClick={logout}
                    >
                        <i className="icon-Esci"/>
                        <span>ESCI</span>
                    </a>
                    {!props.isLogoutOnly && (
                        <div
                            className="tpd_top_icon_third_logout tablet-logout"
                            onClick={logout}
                        >
                            <div className="tablet-esci-logout">ESCI</div>
                            <div className="tpd_top_icon_third_logout_icon">
                                <i className="icon-Esci"/>
                            </div>
                        </div>
                    )}
                </div>
            </UserLogged>
        </>
    )
}

InfoUtente.defaultProps = {
    isLogoutOnly: false,
}
